import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';
import { RootState } from '..';

export interface IEngineSlice {
    images: string[];
}

export interface ISetEngine {
    index: number;
    engine: string;
}

const initialState: IReduxState<IEngineSlice> = {
    status: EReduxState.initialState,
    data: { images: [] },
};

export const engineSlice = createSlice({
    name: 'engine',
    initialState,
    reducers: {
        cleanEngine: state => {
            state.status = EReduxState.initialState;
            state.data = { images: [] };
        },
        setEngine: (state, action: PayloadAction<ISetEngine>) => {
            state.status = EReduxState.fulfilled;
            state.data!.images[action.payload.index] = action.payload.engine;
        },
    },
});

export const { cleanEngine, setEngine } = engineSlice.actions;

export const selectEngine = (state: RootState) => state.engine;

export default engineSlice.reducer;
